import React, { useState, useEffect } from "react";

const ContentTab = ({ handleLayoutChange, selectedLayout,updateAnnouncementBarTabData,announcementBarTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [message, setMessage] = useState(announcementBarTabData.message);
    const [actionElementType, setActionElementType] = useState(announcementBarTabData.action_element_type);
    const [actionElementButtonText, setActionElementButtonText] = useState(announcementBarTabData.action_element_button_text);
    const [actionElementButtonLink, setActionElementButtonLink] = useState(announcementBarTabData.action_element_button_link);
    const [visualElementType, setVisualElementType] = useState(announcementBarTabData.visual_element_type);
    const [visualElementBadgeText, setVisualElementBadgeText] = useState(announcementBarTabData.visual_element_badge_text);
     const [closeButton, setCloseButton] = useState(Number(announcementBarTabData.is_close_button));
    const [barLink, setBarLink] = useState(announcementBarTabData.bar_link);
    const [messageOnMobile, setMessageOnMobile] = useState(announcementBarTabData.message_on_mobile);

    //local states sync
    useEffect(() => {
        setMessage(announcementBarTabData.message);
        setActionElementType(announcementBarTabData.action_element_type);
        setActionElementButtonText(announcementBarTabData.action_element_button_text);
        setActionElementButtonLink(announcementBarTabData.action_element_button_link);
        setVisualElementType(announcementBarTabData.visual_element_type);
        setVisualElementBadgeText(announcementBarTabData.visual_element_badge_text);
        setCloseButton(Number(announcementBarTabData.is_close_button));
        setBarLink(announcementBarTabData.bar_link);
        setMessageOnMobile(announcementBarTabData.message_on_mobile);
    }, [announcementBarTabData]);

    //Handlers Message Change
    const handleMessageChange = (event) => {
        const value = event.target.value;
        setMessage(value);
        updateAnnouncementBarTabData("message", value);
    };

    // Handle Action Element Type change
    const handleActionElementTypeChange = (event) => {
        setActionElementType(event.target.value);
        updateAnnouncementBarTabData("action_element_type", event.target.value);
    };

    //Handlers Action Element Button Text Change
    const handleActionElementButtonTextChange = (event) => {
        const value = event.target.value;
        setActionElementButtonText(value);
        updateAnnouncementBarTabData("action_element_button_text", value);
    };

    //Handlers Action Element Button Link Change
    const handleActionElementButtonLinkChange = (event) => {
        const value = event.target.value;
        setActionElementButtonLink(value);
        updateAnnouncementBarTabData("action_element_button_link", value);
    };

    // Handle Visual Element Type change
    const handleVisualElementTypeChange = (event) => {
        setVisualElementType(event.target.value);
        updateAnnouncementBarTabData("visual_element_type", event.target.value);
    };

    //Handlers Visual Element Badge Text Change
    const handleVisualElementBadgeTextChange = (event) => {
        const value = event.target.value;
        setVisualElementBadgeText(value);
        updateAnnouncementBarTabData("visual_element_badge_text", value);
    };

    //Handlers Is Close Button On Change
    const handleCloseButtonChange = (e) => {
        const checked = e.target.checked;
        setCloseButton(checked);
        updateAnnouncementBarTabData("is_close_button", checked); 
    };
    
    // Handle Bar Link change
    const handleBarLinkChange = (event) => {
        setBarLink(event.target.value);
        updateAnnouncementBarTabData("bar_link", event.target.value);
    };

    //Handlers Message On Mobile Change
    const handleMessageOnMobileChange = (event) => {
        const value = event.target.value;
        setMessageOnMobile(value);
        updateAnnouncementBarTabData("message_on_mobile", value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label>Message</label>
                            <div className="box-header-row welcome-message px-0">
                                <textarea value={message} onChange={handleMessageChange} placeholder="Type Message..." defaultValue=""></textarea>    
                            </div> 
                        </div>
                    </div>
                    <div className="box-header-row bubble-text side-baar-box-header">
                        <label>Action Element</label>
                        <div className="card h-100 position-tabe p-0 border-0">
                            <div className="label-box-flex p-0">
                                <label className="card-radio-btn px-0">
                                    <input type="radio" name="action_element" className="card-input-element d-none" value="None" onChange={handleActionElementTypeChange} checked={actionElementType === "None"}/>
                                    <div className="card card-body">
                                        <div className="content_sub mt-0">None</div>
                                    </div>
                                </label>
                           
                                <label className="card-radio-btn px-0">
                                    <input type="radio" name="action_element" className="card-input-element d-none" value="Button" onChange={handleActionElementTypeChange} checked={actionElementType === "Button"}/>
                                    <div className="card card-body">
                                        <div className="content_sub mt-0">Button</div>
                                    </div>
                                </label>
                            </div>
                            {actionElementType === "Button" && (
                                <>
                                    <div className="box-header-row bubble-text px-0">
                                        <label>Button Text</label>
                                        <input type="text" value={actionElementButtonText} onChange={handleActionElementButtonTextChange} placeholder="" />
                                    </div>
                                    <div className="box-header-row bubble-text px-0">
                                        <label>Button Link</label>
                                        <input type="text" value={actionElementButtonLink} onChange={handleActionElementButtonLinkChange} placeholder="" />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="box-header-row bubble-text side-baar-box-header">
                        <label>Visual Element</label>
                        <div className="card h-100 position-tabe p-0 border-0">
                            <div className="label-box-flex p-0">
                                <label className="card-radio-btn px-0">
                                    <input type="radio" name="visual_element" className="card-input-element d-none" value="None" onChange={handleVisualElementTypeChange} checked={visualElementType === "None"}/>
                                    <div className="card card-body">
                                        <div className="content_sub mt-0">None</div>
                                    </div>
                                </label>
                           
                                <label className="card-radio-btn px-0">
                                    <input type="radio" name="visual_element" className="card-input-element d-none" value="Badge" onChange={handleVisualElementTypeChange} checked={visualElementType === "Badge"}/>
                                    <div className="card card-body">
                                        <div className="content_sub mt-0">Badge</div>
                                    </div>
                                </label>
                            </div>
                            {visualElementType === "Badge" && (
                                <div className="box-header-row bubble-text px-0">
                                    <label>Badge Text</label>
                                    <input type="text" value={visualElementBadgeText} onChange={handleVisualElementBadgeTextChange} placeholder="" />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label>Additional Settings</label>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Close Button</span>
                                <div className="form-group">
                                    <input id="open_is_close_button" className="chkbx-toggle" type="checkbox" checked={closeButton} onChange={handleCloseButtonChange} />
                                    <label for="open_is_close_button"></label> 
                                </div>
                            </div>
                        </div>
                        <div className="box-header-row bubble-text">
                            <label>Bar Link</label>
                            <input type="text" value={barLink} onChange={handleBarLinkChange} placeholder="" />
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("mobile_content_settings")}>Mobile Content Settings
                                <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "mobile_content_settings" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Mobile Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>Message On Mobile</label>
                                <div className="box-header-row welcome-message px-0">
                                    <textarea value={messageOnMobile} onChange={handleMessageOnMobileChange} placeholder="Type Message..." defaultValue=""></textarea>    
                                </div> 
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ContentTab;